import React, { useState } from "react";

import { Menu, MenuItem } from "@material-ui/core";

import { Button} from "../../../../common/components/libs";
import { localize } from "../../../../common/libs";
import { observer } from "mobx-react";
import { useStores } from "../../../../hooks";
import { SnackbarType } from "../../../../stores/common";
import {Trans, useTranslation} from "react-i18next";
import { MenuFormType } from "../../../menu/store/menu/forms";


const ChooseMenu = () => {
    const [menuSelectorAnchorEl, setMenuSelectorAnchorEl] = useState<HTMLElement | null>(null);
    const {generalStore, couponsStore} = useStores();
    const {i18n, t} = useTranslation(["general"]);
    const locale = i18n.language;


    const handleOpenMenuSelectorMenu = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setMenuSelectorAnchorEl(event.currentTarget);
    };

    const setMenu = (menuId: number) => {
        setMenuSelectorAnchorEl(null);
        let menusIds = [];
        menusIds.push(menuId);
        couponsStore.setMenusIds(menusIds);

        couponsStore.getCoupons();
        generalStore.showSnackbar({
            type: SnackbarType.success,
            title: t("general:labelOfUpdating")
        })
    };
    const selectedMenuId = couponsStore.menusIds[0];
    const current = couponsStore.getMenuById(selectedMenuId);


    return (
        <React.Fragment>
            <Button
                mt={2}
                onClick={handleOpenMenuSelectorMenu}
                fullWidth
                variant={'outlined'}
                color={'default'}
                aria-owns={menuSelectorAnchorEl ? "menu-selector" : undefined}
                aria-haspopup="true"
            >
                {current && localize(current.data.name)}
            </Button>
            <Menu
                id="menu-selector"
                anchorEl={menuSelectorAnchorEl}
                open={Boolean(menuSelectorAnchorEl)}
                onClose={() => setMenuSelectorAnchorEl(null)}
            >
                {
                    couponsStore.menusList.map(item => {
                        return <MenuItem
                            key={item.id}
                            onClick={() => {
                                setMenu(item.id);
                            }}
                        >
                            {localize(item.data.name)}
                        </MenuItem>
                    })
                }
            </Menu>
        </React.Fragment>
    );
};


export default observer(ChooseMenu);
